var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CalendarIcon",
      "size": "30"
    }
  }), _vm._v(" Semanas Epidemiológicas ")], 1)]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning",
      "to": '/SemanaEpidemiologica/cadastrar'
    }
  }, [_vm._v(" Nova Semana")])], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refSemanaListTable",
    staticClass: "position-relative",
    attrs: {
      "items": _vm.fetchedSemanas.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "show-empty": "",
      "empty-text": "Nenhuma semana epidemiológica cadastrada"
    },
    scopedSlots: _vm._u([{
      key: "cell(dataInicio)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.dataInicio)) + " ")];
      }
    }, {
      key: "cell(dataFim)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.dataFim)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'SemanaEpidemiologicaEditar',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Editar")])], 1), _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.confirmDelete(data.item.id);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Excluir")])], 1)], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "mx-2 mb-2 mt-1"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-start",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Mostrando " + _vm._s(_vm.fetchedSemanas.content ? _vm.fetchedSemanas.content.length : 0) + " de " + _vm._s(_vm.fetchedSemanas.totalItems || 0) + " registros")])]), _c('b-col', {
    staticClass: "d-flex align-items-center justify-content-center justify-content-sm-end",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('b-pagination', {
    staticClass: "mb-0 mt-1 mt-sm-0",
    attrs: {
      "total-rows": _vm.fetchedSemanas.totalItems || 0,
      "per-page": _vm.perPage,
      "first-number": "",
      "last-number": "",
      "prev-class": "prev-item",
      "next-class": "next-item"
    },
    on: {
      "input": _vm.fetchSemanas
    },
    scopedSlots: _vm._u([{
      key: "prev-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronLeftIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }, {
      key: "next-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronRightIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }